import { orderByValues } from '@/metrics/hooks/useFilters/constants'

export const productColumns = [
  { field: 'sales', label: 'Unidades vendidas', format: 'decimal', orderBy: orderByValues.sales },
  { field: 'count', label: 'Unidades devueltas', format: 'decimal', orderBy: orderByValues.returns },
  { field: 'percentage', label: 'Tasa de devolución de productos', format: 'percent', orderBy: orderByValues.ratio },
]

export const productColumnsWithoutSalesData = [
  { field: 'count', label: 'Devoluciones', format: 'decimal' },
  { field: 'percentage', label: '%', format: 'percent' },
]

export const orderColumns = [
  { field: 'orders', label: 'Pedidos totales', format: 'decimal' },
  { field: 'returned_orders', label: 'Solicitudes', format: 'decimal' },
  { field: 'returned_orders_percentage', label: 'Tasa de devolución de pedidos', format: 'percent' },
]

export const countriesDescriptions = {
  product: 'Por país, cuántas unidades se han devuelto sobre las unidades vendidas totales.',
  order: 'Por país, qué parte de los pedidos ha tenido alguna solicitud de devolución o cambio.',
  withoutSalesData: 'Qué parte de las unidades devueltas corresponde a cada país.',
}
